export default "__VITE_ASSET__D2QAWD0Z__"